import { mapState, mapGetters } from 'vuex';
import { userItemsPerListMixin } from '@/utils/vuex';
import { localizeDate } from '@/utils/date';
import ApiService from '@/services/apiService';
import get from 'lodash/get';
const defaultItemsPerPage = 10;
const defaultTableOptions = {
  sortBy: ['createdAt'],
  sortDesc: [true],
  page: 1,
  itemsPerPage: defaultItemsPerPage
};
export default {
  name: 'CoreBackgroundJobsList',
  mixins: [userItemsPerListMixin],
  props: {},
  data: function () {
    return {
      deletePrompt: false,
      // item for deletion
      selectedItem: {},
      list: [],
      isFetching: false,
      tableOptions: defaultTableOptions,
      serverItemsLength: -1
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
    ...mapGetters({
      sessionUserId: 'authentication/userId'
    }),
    isIotHubRead() {
      return this.permissions['IotHub.read'];
    },
    tableLocalizations() {
      return {
        headers: [{
          text: this.$i18n_t('BackgroundJobs.BackgroundJobs.table.id'),
          value: 'id',
          align: 'center'
        }, {
          text: this.$i18n_t('BackgroundJobs.BackgroundJobs.table.name'),
          value: 'name',
          align: 'start'
        }, {
          text: this.$i18n_t('BackgroundJobs.BackgroundJobs.table.state'),
          value: 'state',
          align: 'start'
        }, {
          text: this.$i18n_t('BackgroundJobs.BackgroundJobs.table.type'),
          value: 'type',
          align: 'start'
        }, {
          text: this.$i18n_t('BackgroundJobs.BackgroundJobs.table.format'),
          value: 'format',
          align: 'start'
        }, {
          text: this.$i18n_t('BackgroundJobs.BackgroundJobs.table.resource'),
          value: 'resource',
          align: 'start'
        }, {
          text: this.$i18n_t('BackgroundJobs.BackgroundJobs.table.createdAt'),
          value: 'createdAt'
        }, ...(this.isIotHubRead ? [{
          align: 'end',
          sortable: false,
          value: 'actions'
        }] : [])],
        footerProps: {
          itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
          itemsPerPageOptions: [defaultItemsPerPage, 20, 50]
        }
      };
    },
    isEmptyList() {
      return this.list.length === 0 && this.serverItemsLength <= 0 && this.isFetching === false;
    }
  },
  watch: {
    canFetch() {
      if (!this.canFetch) {
        return;
      }
      this.fetchList();
    },
    'tableOptions.page'(newVal, oldVal) {
      if (newVal !== oldVal && this.canFetch) {
        this.fetchList();
      }
    }
  },
  async mounted() {
    await this.itemsPerPageReadyPromise;
    this.fetchList();
  },
  methods: {
    fetchList() {
      if (this.isFetching) {
        return;
      }
      this.isFetching = true;
      const {
        sortBy,
        sortDesc,
        page,
        itemsPerPage
      } = this.tableOptions;
      const sortItem = sortBy && sortBy.length ? sortBy[0] : 'createdAt';
      const doSortDesc = sortDesc && sortDesc.length ? sortDesc[0] : true;
      const usedPage = Math.max(1, page || 1);
      const limit = itemsPerPage || defaultItemsPerPage;
      const offset = (usedPage - 1) * limit;
      ApiService.fetchBackgroundJobs(offset, limit, sortItem, doSortDesc).then(res => {
        this.list = res.data;
        this.serverItemsLength = res.pagination.itemCount;
      }).catch(() => {
        this.$snack(this.$i18n_t('BackgroundJobs.BackgroundJobs.snacks.fetchJobFailed'), 'error');
      }).finally(() => {
        this.isFetching = false;
      });
    },
    deletePromise() {
      return ApiService.deleteBackgroundJob(this.selectedItem.id);
    },
    localizeDate,
    showDeletePrompt(item) {
      this.selectedItem = item;
      this.deletePrompt = true;
    },
    deleteItem() {
      this.deletePrompt = false;
      this.deletePromise().then(() => {
        this.$snack(this.$i18n_t('BackgroundJobs.BackgroundJobs.snacks.deleteSuccess'), 'success');
        this.fetchList();
      }).catch(error => {
        console.error(this.$i18n_t('BackgroundJobs.BackgroundJobs.snacks.deleteFailed'), error);
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack(this.$i18n_t('BackgroundJobs.BackgroundJobs.snacks.deleteFailed'), 'error');
        }
      });
    },
    async downloadItem(item) {
      try {
        const res = await ApiService.fetchBackgroundJob(item.id);
        const fileId = get(res, 'result.fileId');
        await ApiService.downloadFile(fileId, `${item.name}.zip`);
      } catch {
        this.$snack(this.$i18n_t('BackgroundJobs.BackgroundJobs.snacks.fetchJobFailed'), 'error');
      }
    }
  }
};